export default "/images/vendor/flag-icon-css/flags/1x1/zm.svg?7d7825c9680bf4c7a1cd8ebc096f3070";